exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".banknotes.base-input {\n  min-height: 3.5rem;\n}\n@media (max-width: 991px) {\n.banknotes.base-input label {\n      font-size: 13px;\n}\n}\n.mt16 {\n  margin-top: 16px;\n}\n", ""]);

// exports
